// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/dist/cjs.js??ref--5-oneOf-1-1!../../node_modules/postcss-loader/src/index.js??ref--5-oneOf-1-2!./core-common.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("4ce5a9f0", content, true, {"sourceMap":false});